import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants, IResponse } from '../models';
import { IConnection } from '../models/i-connection';
import { BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  constructor(
    private http: HttpClient
  ) { }

  GetConnections(): Observable<IResponse<IConnection[]>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Connection/GetConnections`;
    
    return this.http.get<IResponse<IConnection[]>>(url, { headers });
  }

  GetConnection(_id: number): Observable<IResponse<IConnection>> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Connection/GetConnection?id=${_id}`;
    
    return this.http.get<IResponse<IConnection>>(url, { headers });
  }

  StoreConnection(_connection: IConnection): Observable<BaseResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/Connection/StoreConnection`;
    
    return this.http.post<IResponse<BaseResponse>>(url, _connection, { headers });
  }
}
